import {Welcome, Articles, MiscFaq, Tasks} from './blocks';
import React from "react";
import WebinarSignup from "@/pages/dashboards/buddy/new-user/blocks/Webinar.tsx";
import Webinar from "@/pages/dashboards/buddy/new-user/blocks/Webinar.tsx";


const DashboardNewUserContent = () => {
    return (
      <div className="grid lg:grid-cols-3 gap-5 lg:gap-7.5">
        <div className="lg:col-span-2">
          <div className="mb-7.5">
            <Welcome />
          </div>
          {/*<div className="mb-7.5">
                    <Tasks/>
                </div>


              {<div className="mb-7.5">
                    <Webinar/>
                </div>
                <div className="mb-7.5">
                    <MiscFaq/>
                </div>*/}
        </div>
        {/*<div className="lg:col-span-1">
                <div className="mb-7.5">
                    <Articles/>
                </div>


            </div>*/}
      </div>
    );
};

export {DashboardNewUserContent};
